export default "/_next/static/images/02347d7e2d746e3bb02740ff7ad88749.jpg";